export default "__VITE_ASSET__DIUFeGrp__"